// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6a4670e8","498":"3100b1ea","703":"4947d9e5","787":"13ba1745"}[chunkId] + ".chunk.js";
};